<template>
  <div v-if="!initializing" class="usuario-proximas-reservas">
    <div class="mt-150 mt-m-90 cabecera-reservas">
      <span class="text-primary fw-normal mb-none h3">
        {{ $t('reserva.cantidadReservas', gruposFiltrados.length, { count: gruposFiltrados.length }) }}
      </span>
      <div class="filtros-reservas mt-20">
        <FiltrosDropdown
          :titulo="$t('reserva.filtros.titulo')"
          :filtros="filtrosReservas"
          @filtros-aplicados="applyFiltros" />
      </div>
    </div>

    <div class="contenedor-tarjetas mt-30">
      <template v-if="gruposFiltrados.length > 0">
        <div class="row">
          <CardUsuarioReserva
            v-for="grupo in gruposFiltrados"
            :key="grupo.id"
            class="col-12 col-md-3 card-reserva-item"
            :grupo="grupo" />
        </div>
      </template>
      <NotFoundReservaForm v-else :title="$t('reserva.noReservas')" />
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeMount } from 'vue';
  import { proximasExperiencias } from '@/store_pinia/proximasExperiencias';
  import CardUsuarioReserva from '@/components/card/Reserva/CardUsuarioReserva.vue';
  import NotFoundReservaForm from '@/components/form/NotFoundReservaForm';
  import FiltrosDropdown from '@/modules/viajesGrupos/components/FiltrosDropdown.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { generateFiltrosReservas, filterGrupos } from '@/helpers/filtrosUtils';

  const loadingStore = useLoadingStore();
  const storeProxExp = proximasExperiencias();
  const initializing = ref(true);
  const gruposOriginales = ref([]);
  const gruposFiltrados = ref([]);

  const filtrosReservas = computed(() => generateFiltrosReservas());

  function applyFiltros(filtrosAplicados) {
    gruposFiltrados.value = filterGrupos(gruposOriginales.value, filtrosAplicados);
  }

  async function init() {
    try {
      loadingStore.show();
      await storeProxExp.loadProximasExperiencias();
      const grupos = storeProxExp.getGrupos;
      gruposOriginales.value = grupos ? [...grupos] : [];
      gruposFiltrados.value = [...gruposOriginales.value];
    } catch (error) {
      console.error(error);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => await init());
</script>

<style scoped lang="scss">
  .usuario-proximas-reservas {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
  }

  .contenedor-tarjetas .card-reserva-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .filtros-reservas {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
</style>
